import React from "react"
import { IconColor, IconProps } from "@/components/shared/Icon"

export enum SortDirection {
   ASC = "asc",
   DESC = "desc",
}

export enum InputType {
   TEXT = "text",
   EMAIL = "email",
   NUMBER = "number",
   PHONE = "tel",
}

export interface CellRendererArgs<T> {
   value: T[keyof T]
   row: T
   isEditing: boolean
   onInputChange: (field: keyof T, value: string) => void
   onBulkPaste?: (rows: string[]) => void
   hasError?: boolean
   cellTextTestId?: string
}

export type Column<T> = {
   key: keyof T
   label: string
   width?: number
   minWidth?: number
   inputType?: InputType
   sortable?: boolean
   icon?: IconProps["name"]
   editable?: boolean
   dimmable?: boolean
   cellTextTestId?: string
   renderCell?: (props: CellRendererArgs<T>) => React.ReactNode
}

export interface CreateTextCellRendererProps<T> {
   inputType?: InputType
   field: keyof T
   placeholder?: string
   disabled?: boolean
   iconName?: string
   iconColor?: IconColor
   iconSize?: string
   showOnlyOnView?: boolean
   isBulkCreation?: boolean
   onIconClick?: (id: string) => void
   onTextClick?: (row: T) => void
}

export interface TextCellRendererProps<T> {
   inputType?: InputType
   field: keyof T
   value: T[keyof T]
   isEditing: boolean
   onInputChange: (field: keyof T, value: string) => void
   onBulkPaste?: (rows: string[]) => void
   hasError?: boolean
   placeholder?: string
}
